import React, { useEffect, useState } from "react";
import {
  checkIfPlayerBoxTypeDocExists,
  getBoxTypeDocuments,
  incrementBoxTypeUsed,
  updatePlayerAttribute,
} from "../firebase/fireFuncs";
import { addPropertyToGeneralObject, objectToArray } from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";
import BoxTypeHolder from "./BoxTypeHolder";
import collectionStore from "./../stores/collectionStore";

const GlobalBoxTypesList = ({ onDelete }) => {
  const { player } = MainStore();
  const [boxTypes, setBoxTypes] = useState([]);
  const { setGeneralObjects } = collectionStore();

  function onNameClicked(boxType) {
    addPropertyToGeneralObject(boxType.names.plural, setGeneralObjects);
    if (player.boxTypes[boxType.names.plural]) onDelete(boxType);
    else {
      incrementBoxTypeUsed(boxType.names.plural, 1);
      checkIfPlayerBoxTypeDocExists(player.uid, boxType.names.plural, () => {});
      const newBoxTypes = { ...player.boxTypes };
      newBoxTypes[boxType.names.plural] = boxType;
      updatePlayerAttribute(player.uid, "boxTypes", newBoxTypes);
    }
  }

  function onTypesDocuments(boxTypes) {
    setBoxTypes(objectToArray(boxTypes));
  }

  useEffect(() => {
    getBoxTypeDocuments(onTypesDocuments);
  }, []);

  return (
    <div className="divColumn" style={{ width: "52%" }}>
      <div
        className="textBoldWhite"
        style={{
          minWidth: "800px",
          fontSize: "20px",
          width: "100%",
          backgroundColor: "#4f4f4f",
          textAlign: "center",
        }}
      >
        Your Boxtypes
      </div>
      <div className="divColumn" style={{ width: "100%" }}>
        {boxTypes.map((boxType, index) => (
          <BoxTypeHolder
            boxType={boxType.value}
            key={index}
            playerBoxtypes={objectToArray(player.boxTypes)}
            onClick={onNameClicked}
          />
        ))}
      </div>
    </div>
  );
};

export default GlobalBoxTypesList;
